import { environment } from "./environment";
import { scriptLoader } from "./script-loader"
import { getUserCompany } from "./user-service";
interface BookIt {
	getUniqueId():string;
	submit({formData}:{formData:object});
}

export const LEAN_DATA_MKTO_FIELD = 'LD_BookIt_Log_ID__c';
export class LeanDataService {
	private constructor(private bookit: Promise<BookIt>){};

	static tryInit(): LeanDataService | null {
		const form = document.querySelector<HTMLFormElement>('form[data-ldbookit]');
		const nodeName = form?.dataset.ldbookit;
		if(!nodeName) return null;
		
		const bookit = scriptLoader.loadScript('https://cdn.leandata.com/js-snippet/ld-book-v2.js')
			.then(() => window['LDBookItV2'])
			.then(ld => {
				ld.initialize(environment.leanDataBookitOrgId, nodeName, LEAN_DATA_MKTO_FIELD, {
					skipSubmissionConfirmation: true
				});
				return ld;
			});

		return new LeanDataService(bookit);
	}

	getLeanDataId():Promise<string> {
		return this.bookit.then(bookit => bookit.getUniqueId());
	}
	
	submit(formData: object, redirect?: string): Promise<void> {
		const company$ = formData['Email'] ? getUserCompany(formData['Email']) : Promise.resolve({});
		return Promise.all([this.bookit, company$])
		.then(([bookit, company]) => {
			const { name, tags, category, metric, geo } = company;

			window.addEventListener('message', e => {
				if(['LD_POST_BOOKING_IMMEDIATE', 'LD_POPUP_CLOSED'].includes(e.data.message))
					window.location.assign(redirect || '/thank-you');
			});

			bookit.submit({formData: {
				...formData, 
				title: name,
				employeeCount: metric?.employees,
				annualRevenue: metric?.annualRevenue,
				tags,
				industry: category?.industry,
				sector: category?.sector,
				country: geo?.country
			}});
		});
	}
}